import { FunctionComponent, useEffect, useState } from "react";
import { Modal } from "antd";
import { ReactComponent as LightOn } from "src/static/images/light-on.svg";
import { CloseOutlined } from "@ant-design/icons";
import TipCard from "@components/cards/TipCard";
import ExpertCard from "@components/cards/ExpertCard";
import { requestGetTips } from "@state/em_tips/EMTipsEffects";
import { TipsResponseDTO } from "@state/em_tips/dto/tips.response.dto";

interface TipsModalProps {
  title?: string | JSX.Element;
  visible: boolean;
  onOk?: () => void;
  onCancel: () => void;
  onShare?: () => void;
  onSave?: () => void;
  onClickExpert: () => any;
  className?: string;
}

const TipsModal: FunctionComponent<TipsModalProps> = ({
  title,
  visible,
  onOk,
  onCancel,
  onClickExpert,
  className = "",
  onShare,
  onSave,
}) => {
  const [tips, setTips] = useState<TipsResponseDTO[]>([]);

  useEffect(() => {
    if (visible && (!tips || !tips.length)) requestGetTips({});
  }, [visible]);

  useEffect(() => {
    return requestGetTips.done.watch(({ result }) => {
      if (result.ok && result.data) {
        setTips(result.data);
      }
    });
  });

  return (
    <>
      <Modal
        centered
        title={null}
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        className={`app-modal tips-modal ${className}`}
        closable={false}
        footer={null}
        zIndex={10000}
      >
        <button className="close-button" onClick={onCancel}>
          <CloseOutlined size={48} />
        </button>
        <div className="tips-modal-container">
          {title && (
            <div className="tips-modal-title">
              <LightOn aria-hidden="true" focusable="false" />
              <h2 className="title">{title}</h2>
            </div>
          )}
          {tips.map((tip, index) => (
            <TipCard key={index} tip={tip} onShare={onShare} onSave={onSave} />
          ))}
          <ExpertCard onClick={onClickExpert} />
        </div>
      </Modal>
    </>
  );
};

export default TipsModal;
